// import { ascend, compose, descend, prop, sortWith, toLower } from 'ramda'
import ascend from 'ramda/src/ascend'
import compose from 'ramda/src/compose'
import descend from 'ramda/src/descend'
import prop from 'ramda/src/prop'
import sortWith from 'ramda/src/sortWith'
import toLower from 'ramda/src/toLower'

export function sortOrder(data, key, ascending) {
  if (!data.length) return

  let sortData

  if (typeof data[0][key] === 'string') {
    sortData = ascending
      ? sortWith([ascend(compose(toLower, prop(key)))])
      : sortWith([descend(compose(toLower, prop(key)))])
  } else if (typeof data[0][key] === 'boolean') {
    // sort by boolean, then title
    sortData = ascending
      ? sortWith([descend(prop(key)), ascend(compose(toLower, prop('title')))])
      : sortWith([ascend(prop(key)), ascend(compose(toLower, prop('title')))])
  } else {
    sortData = ascending ? sortWith([ascend(prop(key))]) : sortWith([descend(prop(key))])
  }

  return sortData(data)
}



// WEBPACK FOOTER //
// ./src/modules/Forms/utils/sort.js